import { AlpineLily } from "./Presets/AlpineLily";
import { BabyBlueEyes } from "./Presets/BabyBlueEyes";
import { BlackEyedSusan } from "./Presets/BlackEyedSusan";
import { BlanketFlower } from "./Presets/BlanketFlower";
import { CaliforniaPoppy } from "./Presets/CaliforniaPoppy";
import { CarolineTestout } from "./Presets/CarolineTestout";
import { CommonCamas } from "./Presets/CommonCamas";
import { DouglasAster } from "./Presets/DouglasAster";
import { Godetia } from "./Presets/Godetia";
import { LanceLeafCoreopsis } from "./Presets/LanceLeafCoreopsis";
import { LewisiaCotyledon } from "./Presets/LewisiaCotyledon";
import { RedCornPoppy } from "./Presets/RedCornPoppy";
import { Trillium } from "./Presets/Trillium";
import { Tulip } from "./Presets/Tulip";
import { WesternAzalea } from "./Presets/WesternAzalea";
import { WesternCosmos } from "./Presets/WesternCosmos";

export const Presets = [
    AlpineLily, BabyBlueEyes, BlackEyedSusan,
    BlanketFlower, CaliforniaPoppy, CarolineTestout,
    CommonCamas, DouglasAster, Godetia,
    LanceLeafCoreopsis, LewisiaCotyledon, RedCornPoppy,
    Trillium, Tulip, WesternAzalea,
    WesternCosmos];
